//
//  src/components/profile/Profile.js
//
import React, { useState, useEffect } from "react";
import profileImage from '../../images/profile.webp';
import './Profile.css';


//
//  profile
//
export default function Profile() {
    const [isVisible, setIsVisible] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        // Trigger animation on mount
        setIsVisible(true);
    }, []);

    return (
        <div className={`profile-container ${isVisible ? 'visible' : ''}`}>
            <div className="profile-content">
                <h1 className="contact-choice-title">About Me</h1>
                <div className="profile-content-grid">
                    <div className="profile-image-wrapper">
                        <div className={`profile-image-container ${imageLoaded ? 'loaded' : ''}`}>
                            <img
                                src={profileImage}
                                alt="Jeff Tattooer - Professional Tattoo Artist"
                                className="profile-image"
                                onLoad={() => setImageLoaded(true)}
                                loading="eager"
                            />
                            <div className="profile-image-overlay"></div>
                        </div>
                    </div>
                    <div className="profile-text-wrapper">
                        <div className={`profile-text-content ${isVisible ? 'visible' : ''}`}>
                            <div className="profile-text">
                                <p>
                                    With over 8 years of experience in the art of tattooing, I have established myself as a master of my craft, 
                                    specializing in realistic tattoo artwork, blackwork, traditional, and neo-traditional designs. My journey began with a 
                                    passion for art and a deep appreciation for the permanence and meaning that tattoos hold for my clients.
                                </p>
                                <p>
                                    I work across various tattoo styles, including black and grey realism and traditional designs. Each piece 
                                    combines technical skill with creative expression, and I enjoy exploring different approaches to bring 
                                    ideas to life on skin.
                                </p>
                                <p>
                                    Throughout my career, I have honed my skills working with clients from all walks of life, creating custom designs 
                                    that reflect their unique personalities and experiences. My dedication to the craft extends beyond the studio, as I 
                                    continuously study new techniques and stay current with the latest trends in tattoo artistry.
                                </p>
                                <p>
                                    What sets my work apart is my commitment to understanding each client's vision and translating it into a design that 
                                    exceeds their expectations. I believe in open communication and collaboration throughout the entire process, from initial 
                                    consultation to final touch-ups. This collaborative approach ensures that every tattoo is not only visually stunning but 
                                    also deeply personal and meaningful to the individual wearing it.
                                </p>
                                <p>
                                    Whether you're looking for a small, meaningful piece or a full-body transformation, I bring years of experience, 
                                    artistic integrity, and a genuine passion for creating tattoos that will last a lifetime.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

